import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { CONFIG } from 'app/config/config';
import { Session } from 'app/shared/services/session/session.service';
import { PushNotification, Page } from '../models'

@Injectable()
export class PushService {
  appName: string;

  pages: Page[] = [];
  notifications: PushNotification[] = [];

  constructor(private _http: Http, private _session: Session) { }

  initialize(app: string) {
    this.appName = app;
  }

  save(data: any) {
    return this._http.post(CONFIG.ENDPOINT_URL + 'apps/' + this.appName + '/notifications', { data: data }, { headers: this._session.headers() })
    .toPromise();
  }

  getAllNotifications() : Promise<PushNotification[]> {
    return this._http.get(CONFIG.ENDPOINT_URL + 'apps/' + this.appName + '/notifications', { headers: this._session.headers() })
    .toPromise()
    .then(response => {
      let jsonNotifications = response.json();
      let notifications = jsonNotifications.map(jsonNotification => new PushNotification(jsonNotification));
      this.notifications.length = 0;
      [].push.apply(this.notifications, notifications);
      this.updateNotificationsWithPages();

      return this.getSortedNotifications();
    });
  }

  getNotification(id: any) {
    return this._http.get(CONFIG.ENDPOINT_URL + 'apps/' + this.appName + '/notifications/' + id, { headers: this._session.headers() })
    .toPromise()
    .then(response => {
      let jsonNotification = response.json();
      let notification = new PushNotification(jsonNotification);
      this.updateNotificationWithPage(notification);
      return notification;
    });
  }

  // Called when pages or nav items are updated
  updateNotificationsWithPages(pages?: Page[]) {
    if (!pages) pages = this.pages;
    this.pages = pages;
    this.notifications.forEach(notification => {
      this.updateNotificationWithPage(notification);
    });
  }

  updateNotificationWithPage(notification: PushNotification) {
    let page = this.pages.filter(page => page.id === notification.targetID);
    if (page.length) notification.targetPage = page[0];
    else notification.targetPage = null;
  }

  getSortedNotifications() : PushNotification[] {
    let delivered: PushNotification[] = [];
    let scheduled: PushNotification[] = [];
    let today: Date = new Date();
    
    this.notifications.forEach(notification => {
      if(notification.pushDateObject > today) scheduled.push(notification);
      if(notification.pushDateObject < today) delivered.push(notification);
    });

    let sortFn = function(a,b) {
      if(a.pushTime > b.pushTime) return -1;
      if(a.pushTime < b.pushTime) return 1;
      return 0;
    };

    delivered = delivered.sort(sortFn);
    scheduled = scheduled.sort(sortFn);

    return scheduled.concat(delivered);
  }  

  delete(id: any) {
    return this._http.delete(CONFIG.ENDPOINT_URL + 'apps/' + this.appName + '/notifications/' + id, { headers: this._session.headers() })
    .toPromise();
  }

  edit(id: any, data: any) {
    return this._http.patch(CONFIG.ENDPOINT_URL + 'apps/' + this.appName + '/notifications/' + id, { data: data }, { headers: this._session.headers() })
    .toPromise();
  }
}


// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/helpers/push.service.ts